import { render, staticRenderFns } from "./NewSteps.vue?vue&type=template&id=8dc56ece&scoped=true"
import script from "./NewSteps.vue?vue&type=script&lang=js"
export * from "./NewSteps.vue?vue&type=script&lang=js"
import style0 from "./NewSteps.vue?vue&type=style&index=0&id=8dc56ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc56ece",
  null
  
)

export default component.exports